  <mat-dialog-content class="containerPhotos" >
    <img class="mat-elevation-z8" src="{{imageSrc}}" [ngStyle]="sizePicture">
  </mat-dialog-content>

  
  